var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.stringsStore.stringsLoaded)?_c('div',{attrs:{"id":"app"}},[(_vm.env === 'dev')?_c('div',{staticClass:"staging"},[_c('span',[_vm._v("⚠️")]),_vm._v("\n      Let op! Je gebruikt de staging-omgeving.\n      "),_c('span',[_vm._v("⚠️")])]):_vm._e(),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }